import { z } from "zod";

export const GetSampleRequestParamsSchema = z.object({
  sample: z.string(),
});

export type GetSampleRequestParamsType = z.infer<
  typeof GetSampleRequestParamsSchema
>;

export const GetSampleResponseBodySchema = z.object({
  sample: z.any(),
});

export type GetSampleResponseBodyType = z.infer<
  typeof GetSampleResponseBodySchema
>;
